export const addSiteInitialValue = {
  siteName: "",
  description: "",
  addressLine1: "",
  addressLine2: "",
  postalCode: "",
  city: "",
  state: "",
  country: "",
  latitude:"",
  longitude:"",
  maxDepth:"",
  diveType:"",
};
export const updateSiteInitialValue = {
  siteName: "",
  description: "",
  addressLine1: "",
  addressLine2: "",
  postalCode: "",
  city: "",
  state: "",
  country: "",
  latitude:"",
  longitude:"",
  isRecommend:false,
  isBestDestination:false,
  maxDepth:"",
  diveType:"",
  defaultImage:"",
};
export const editProfileInitialValues = {
  firstName :'',
  lastName :"",
  mobileNo:"",
  defaultImage:"",
}
